export const getFaqsList = [
    {
        question: "Is there an age restriction for the event?",
        answer: `<p> No, venue is open for all ages, but tickets are required for attendees above 10 years if age. </p>`
    },
    {
        question: "Is there parking available?",
        answer: "<p>Yes, limited parking facilities are available at the venue.</p>"
    },
    {
        question: "Can I get a refund if I can't attend the event?",
        answer: "<p>No, tickets for the event re non-refundable.</p>"
    },
    {
        question: "What is the dress code for the event?",
        answer: `Since it is a Navratri event, traditional attire is required.`
    },
    {
        question: "Is the venue wheelchair accessible?",
        answer: `Yes, the venue is wheelchair accessible.`
    },
    {
        question: "Will food, beverages, and alcohol be available at the venue?",
        answer: "<p>Food and beverages will be available. Alcohol will not be served.</p>"
    },
    {
        question: "Is re-entry to the venue allowed?",
        answer: "<p>No, re-entry is not permitted once you exit.</p>"
    },
    {
        question: "Is there a designated smoking area?",
        answer: "<p>Yes, a designated smoking area will be provided.</p>"
    },
];